import { render, staticRenderFns } from "./SelfTerminationModal.vue?vue&type=template&id=48f88d05&scoped=true&"
import script from "./SelfTerminationModal.vue?vue&type=script&lang=js&"
export * from "./SelfTerminationModal.vue?vue&type=script&lang=js&"
import style0 from "./SelfTerminationModal.vue?vue&type=style&index=0&id=48f88d05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f88d05",
  null
  
)

component.options.__file = "SelfTerminationModal.vue"
export default component.exports